import Header from "../Header/Header";
import HorizontalCardIlustrations from "../HorizontalCardIlustrations/HorizontalCardIlustrations";
import HorizontalCardPrices from "../HorizontalCardPrices/HorizontalCardPrices";
import ContactCard from "../ContactCard/ContactCard";
import Video from "../Video/Video";
import ReviewCarousel from "../ReviewCarousel/ReviewCarousel";
import CarouselMateriales from "../CarouselMateriales/CarouselMateriales";
import Seo from "../Seo/Seo";

const Main = ({ materialesTotales }) => {
  return (
    <main>
      <Seo
        title="Learn Spanish Online with a Native Teacher"
        description="Fun, practical online Spanish lessons with a native teacher from Galicia. Free materials, courses, and 1-to-1 classes for learners worldwide."
        path="/"
      />
      <Header materialesTotales={materialesTotales} />
      <CarouselMateriales materialesTotales={materialesTotales} />
      <HorizontalCardPrices />

      <HorizontalCardIlustrations />
      {/* <BoxInfoTemplate
        title=""
        subTitle=""
        mainText="Don’t let this opportunity slip away, tío!"
        iconType="redDot"
        showQuotes={true}
        showShadow={true}
        borderColor="orange"
      /> */}
      <ReviewCarousel />

      <ContactCard />
      {/* <ConversationZoom /> */}
      <Video />
    </main>
  );
};

export default Main;
